import MaskUtil from "../../util/MaskUtil";

const BeneficiarySocialSecurityNumberDirective = angular
    .module("BeneficiarySocialSecurityNumberDirective", [])
    .directive("pwSocialSecurityNumber", socialSecurityNumber);

/**
 *  NOTE: The original SocialSecurityNumberDirective is causing issues in mobile screens where the masks aren't applying/functioning
 *          correctly. This is due to the use of jquery inputmask in the pwMask directive which is a known issue.
 *          There are numerous directives for items like DOB SSN being used within the application. There needs to be
 *          an effort to consolidate into a single directive that works across all apps.
 */
function socialSecurityNumber() {
    return {
        require: "ngModel",
        restrict: "A",
        priority: 1000,
        link: function (scope, element, attr, ctrl) {
            const pattern = /^\d{9}$/;

            ctrl.$validators.ssnDigits = function (modelValue, viewValue) {
                if (ctrl.$isEmpty(modelValue)) {
                    // consider empty models to be valid
                    return true;
                }
                //masked is valid.
                if (modelValue && modelValue.indexOf(MaskUtil.MASK_CHAR) !== -1) {
                    return true;
                }
                if (pattern.test(modelValue)) {
                    // it is valid
                    return true;
                }
                // it is invalid
                return false;
            };
        }
    };
}

export default BeneficiarySocialSecurityNumberDirective;
